import { render } from "./eventtype.vue?vue&type=template&id=e866c3fc&scoped=true"
import script from "./eventtype.vue?vue&type=script&lang=js"
export * from "./eventtype.vue?vue&type=script&lang=js"

import "./eventtype.vue?vue&type=style&index=0&id=e866c3fc&lang=scss&scoped=true"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e866c3fc"]])

export default __exports__